/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Status_TrialingInputs */

const fr_membership_status_trialing = /** @type {(inputs: Membership_Status_TrialingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Période d'essai`)
};

/**

* @param {Membership_Status_TrialingInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_status_trialing = /** @type {((inputs?: Membership_Status_TrialingInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Status_TrialingInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_status_trialing(inputs)
});